import { Pipe, PipeTransform } from '@angular/core';
import { Marcas } from '../_model/marcas';

@Pipe({
    name: 'toMatrix',
    standalone: false
})
export class MatrixPipe implements PipeTransform {
  transform(arr: any[], n: number): any[][] {
    const rows = Array.from({ length: Math.ceil(arr.length / n) }, (_, i) => i);
    return rows.map(idx => arr.slice(idx * n, idx * n + n));
  }

}
